import {
  AcademyDTO,
  AcademyMetadataDTO,
  AttendanceDTO,
  StudentDTO,
  StudentWithAttendanceDTO,
  UserDTO,
} from "src/dto";
import { DefaultResponse, Pagination } from "types/default";

import { maxios } from "./";
import AdapterService from "./adapter.service";

class ApiService {
  constructor(private adapter: AdapterService) {}

  async ping() {
    const {
      data: { data },
    } = await maxios.get<DefaultResponse<UserDTO>>("/ping");
    return data;
  }
  async getAcademies() {
    const {
      data: { data },
    } = await maxios.get<DefaultResponse<AcademyDTO>>("/academies");
    return data;
  }
  async getStudents() {
    const {
      data: {
        data: { content },
      },
    } = await maxios.get<Pagination<StudentDTO[]>>(
      `/students?page=0&size=1000000&status=ACTIVE`
    );

    return content.map(this.adapter.from.studentWithAttendance);
  }

  async getTodayAttendances() {
    const queryString = this.adapter.to.todayAttendances();

    const {
      data: { data },
    } = await maxios.get<
      DefaultResponse<
        {
          date: `${number}-${number}-${number}`; // yyyy-MM-dd
          attendanceList: AttendanceDTO[];
        }[]
      >
    >(`/attendances?${queryString}`);
    return data;
  }

  async postLogin(params: req.login) {
    const {
      data: { data },
    } = await maxios.post<DefaultResponse<UserDTO>>("/login", params);

    return data;
  }

  async postResetPassword(data: req.reset) {
    await maxios.post("/password/reset-token", data);
  }

  async postAttendancesEnter(student: StudentWithAttendanceDTO) {
    const params = this.adapter.to.enter(student);
    // 출석앱 전용 신규 API는 공통 래퍼 없이 배열을 직접 반환한다.
    const { data } = await maxios.post<AttendanceDTO[]>(
      "/attendance-app/attendances/enter",
      params
    );
    return this.adapter.from.attendanceInfo(data);
  }
  async postAttendancesQuit(student: StudentWithAttendanceDTO) {
    const params = this.adapter.to.quit(student);
    // 출석앱 전용 신규 API는 공통 래퍼 없이 배열을 직접 반환한다.
    const { data } = await maxios.post<AttendanceDTO[]>(
      "/attendance-app/attendances/quit",
      params
    );

    return this.adapter.from.attendanceInfo(data);
  }

  async patchMetadata(data: AcademyMetadataDTO) {
    await maxios.patch("/academies/metadata", data);
  }
}

const api = new ApiService(new AdapterService());
export default api;
